// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1-qgl","approved":"Status_approved__3a0ai","rejected":"Status_rejected__2h-Ki","expired":"Status_expired__2iBlU","label":"Status_label__2arfU"};